// Holds the one Stream Chat client of the app.
// Kept in its own file (no imports) so that api.js and App.js can disconnect the chat on logout.

let activeStaffChatClient = null;

export const setActiveStaffChatClient = (client) => {
  activeStaffChatClient = client;
};

export const getActiveStaffChatClient = () => {
  return activeStaffChatClient;
};

// Close the chat connection, so the user is shown offline at once
export const disconnectStaffChat = () => {
  const client = activeStaffChatClient;
  activeStaffChatClient = null;

  if (client) {
    client.disconnectUser().catch((error) => {
      console.error("Error disconnecting chat:", error);
    });
  }
};
